export default __webpack_public_path__ + "media/images/ui-icons_444444_256x240-79b89cc07096d272b27edefcce2da120.png";